import { List } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';
import { Record } from 'immutable';

const EligibleServicesState = new Record({
    services: new List(),
    loading: true,
    error: null
});

export class EligibleServicesStore extends BaseStore {

    getInitialState () {
        return new EligibleServicesState();
    }

    getActionHandlers () {
        return {
            [ ActionTypes.ELIGIBLE_SERVICES_SEARCH_STARTED ]: this.handleSearchStarted,
            [ ActionTypes.ELIGIBLE_SERVICES_SEARCH_FINISHED ]: this.handleSearchFinished,
            [ ActionTypes.ELIGIBLE_SERVICES_SEARCH_FAILED ]: this.handleSearchFailed,
            [ ActionTypes.ELIGIBLE_SERVICES_RESET ]: this.handleReset,
        };
    }

    handleSearchStarted () {
        this.setState(this.state.set('loading', true));
    }

    handleSearchFinished ({ services }) {
        setTimeout(() => {
            this.setState(
                this.state.merge({
                    services,
                    loading: false,
                }),
            );
        }, 2000);
    }

    handleSearchFailed ({ error }) {
        this.setState(this.state.merge({loading: false, error}));
    }

    handleReset () {
        this.setState(this.state.merge({loading: true, error: null}));
    }
}

const storeInstance = new EligibleServicesStore();

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/EligibleServicesStore.js